module.exports = __webpack_public_path__ + "static/img/caiyun_.1fb73286.png";